import './ClubConfirmViewBar.css';

export function ClubConfirmViewBar({
  show,
  canCancel = false,
  saving = false,
  onConfirm,
  onCancel,
}) {
  if (!show) return null;
  return (
    <div
      className="club-confirm-view"
      data-testid="club-confirm-view"
      role="region"
      aria-label="Set club view"
    >
      <div className="club-confirm-view__card">
        <div className="club-confirm-view__copy">
          <h2 className="club-confirm-view__title">Set the club view</h2>
          <p>Pan and zoom until this is the widest view. Members can zoom in and tilt, but not pull out past here.</p>
        </div>
        <div className="club-confirm-view__actions">
          <button
            type="button"
            className="club-confirm-view__btn club-confirm-view__btn--primary"
            data-testid="club-confirm-view-save"
            disabled={saving}
            onClick={() => onConfirm && onConfirm()}
          >
            {saving ? 'Saving…' : 'Confirm view'}
          </button>
          {canCancel ? (
            <button
              type="button"
              className="club-confirm-view__btn"
              data-testid="club-confirm-view-cancel"
              disabled={saving}
              onClick={() => onCancel && onCancel()}
            >
              Cancel
            </button>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default ClubConfirmViewBar;
